// const base_url = "http://127.0.0.1:8000";
// const base_url = "https://dev.api.meetminutes.in";
const base_url = "https://api.meetminutes.in";

let configs = {
    base_url: base_url,
    signin_url: `${base_url}/security/signin`,
    signup_url: `${base_url}/security/signup`,
    social_signup_url: `${base_url}/security/social-signup`,
    get_id_token_url: `${base_url}/security/get_id_token`,
    user_url: `${base_url}/user`,
    user_bot_meetings_url : `${base_url}/user/bot-meetings`,
    user_calendar_meetings_url : `${base_url}/user/calendar-meetings`,
    meetings_url : `${base_url}/user/meetings`,
    stats_meetings_url : `${base_url}/user/stats-meetings`,
    get_team_admin_url : `${base_url}/report/get_team_admins`,
    get_report_url : `${base_url}/report/get_report`,
    send_notes_email: `${base_url}/emails/send_notes`
}

export default configs